/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import * as X from "@/ui";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import type { Swiper as SwiperInstance } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import { WhatDriveUs } from "@/providers/strapi/content/types/components/about-us.component";
import { useAboutUsPage } from "@/providers/strapi/content/types/singleTypes/about-us-page";
import ReactMarkdown from "react-markdown";


// const defaultData = {
//   values: [
//     {
//       title: { en: `Customer first`, fr: `Le client avant tout` },
//       text: {
//         en: `We proactively seek feedback and prioritize customer needs in every decision. We aim to exceed expectations by creating simple, high-performing solutions.`,
//         fr: `Nous recherchons activement le feedback de nos clients et priorisons leurs attentes lors de chaque décision. Nous veillons à dépasser leurs attentes en créant des produits simples et performants.`
//       },
//     },
//     {
//       title: { en: `Dream big`, fr: `Rêver grand` },
//       text: {
//         en: `We aim high in everything we do. Our potential is big, so we think boldly, set audacious goals, and deliver fast and with excellence`,
//         fr: `Nous visons haut. Notre potentiel est important, c'est pourquoi nous pensons avec audace. Nous fixons des objectifs ambitieux et nous délivrons rapidement et avec excellence.`,
//       },
//     },
//     {
//       title: { en: `Get things done`, fr: `Passer à l’action` },
//       text: {
//         en: `We are empowered and make things happen. We are doers. We combine attention to details, rigor, speed and excellence. We hold ourselves accountable.`,
//         fr: `Nous sommes autonomes et faisons bouger les choses. Nous allions attention aux détails, rigueur, rapidité et excellence. Nous prenons la  responsabilité de nos actions.`,
//       },
//     },
//     {
//       title: { en: `Win together`, fr: `Gagner ensemble` },
//       text: {
//         en: `We seek out different perspectives to sharpen our ideas. We communicate transparently without being rude. We want professionalism and friendliness to coexist.`,
//         fr: `Nous croyons à la force du collectif. Chacun apporte sa perspective pour affiner nos idées et aller plus loin. Nous communiquons avec transparence, sans être brusques. Nous voulons que professionnalisme et convivialité coexistent.`,
//       },
//     },
//     {
//       title: { en: `Be driven`, fr: `Être déterminé` },
//       text: {
//         en: `We relentlessly push ourselves to go the extra mile. We show intensity and are committed to deliver exceptional results every day. We think positive and have fun.`,
//         fr: `Nous nous surpassons sans relâche. Nous faisons preuve d’intensité et d’engagement pour obtenir des résultats exceptionnels chaque jour. Nous sommes positifs.`,
//       },
//     },
//     {
//       title: { en: `Be creative`, fr: `Oser innover` },
//       text: {
//         en: `We pursue innovative solutions and never settle for the first or easiest answer. We challenge the status quo to keep innovating.`,
//         fr: `Nous aimons les idées nouvelles. Nous remettons en question le statu quo et cherchons toujours à faire mieux. L’innovation est notre moteur.`,
//       },
//     },
//   ]
// }

type ViewModel = {
  values: Array<{
    title: string;
    text: string;
  }>
}

const buildData = (content: WhatDriveUs): ViewModel => ({
  values: content.slides.map((s) => ({
    title: s.title,
    text: s.content
  }))

  // [
  //   {
  //     title: { en: `Customer first`, fr: `Le client avant tout` },
  //     text: {
  //       en: `We proactively seek feedback and prioritize customer needs in every decision. We aim to exceed expectations by creating simple, high-performing solutions.`,
  //       fr: `Nous recherchons activement le feedback de nos clients et priorisons leurs attentes lors de chaque décision. Nous veillons à dépasser leurs attentes en créant des produits simples et performants.`
  //     },
  //   },
  // ]
})


export function ValuesSection(_props: X.PageProps) {
  // const tr = X.useTranslator();
  const content = useAboutUsPage('whatDriveUsCard');

  return (
    <section id="values" className={X.clsx("scroll-mt-[120px] xl:mt-24 relative")}>
      {/* <h2 className="text-[35px] xl:text-[48px] max-w-[50%] [&_strong]:font-medium xl:text-center xl:max-w-content mx-mobile-margin xl:mx-auto mb-8 xl:mb-16 leading-tight">
        {tr({
          en: <>What <strong>Drives Us</strong></>,
          fr: <>Ce qui <strong>nous anime</strong></>,
        })}
      </h2> */}
      <ReactMarkdown
        components={{
          p: ({ ...props }) => <h2 {...props} className="text-[35px] xl:text-[48px] max-w-[50%] [&_strong]:font-medium xl:text-center xl:max-w-content mx-mobile-margin xl:mx-auto mb-8 xl:mb-16 leading-tight" />
        }}
      >
        {content.title}
      </ReactMarkdown>
      <div className={X.mobileOnly()}>
        <SliderMobile />
      </div>

      <div className={X.clsx(X.desktopOnly("block"), "max-w-content mx-auto")}>
        <SliderDesktop />
      </div>
    </section>
  );
}


function SliderMobile() {
  const id = X.useId();
  const content = useAboutUsPage('whatDriveUsCard');
  const data = buildData(content)
  return (
    <Swiper
      modules={[Pagination]}
      spaceBetween={16}
      slidesPerView={1.28}
      className="xl:h-full"
      slidesOffsetBefore={32}
      slidesOffsetAfter={32}
      pagination={{
        el: `#${id}`,
        bulletActiveClass: "w-8 !bg-surface-gray-darker",
        bulletClass: "block w-2 h-2 bg-surface-gray rounded-full transition-all duration-300",
        clickable: false,
      }}
    >
      {data.values.map((value, i) => (
        <SwiperSlide key={i}>
          <Slide value={value} index={i} />
        </SwiperSlide>
      ))}

      <div id={id} className="mx-mobile-margin flex flex-row gap-2 mt-4" />
    </Swiper>
  );
}


function SliderDesktop() {
  const ref = X.useRef<SwiperInstance | null>(null);
  const [, forceUpdate] = X.useState({});

  X.useEffect([ref.current], () => {
    if (!ref.current) {
      return;
    }

    const s = ref.current;
    const update = () => forceUpdate({});
    s.on("slideChange", update);

    return () => s.off("slideChange", update);
  });

  const content = useAboutUsPage('whatDriveUsCard');
  const data = buildData(content)

  return (
    <div className="relative px-4 xl:px-0">
      <div className="relative max-w-content mx-auto overflow-hidden">
        <Swiper
          modules={[Pagination]}
          spaceBetween={24}
          slidesPerView={3}
          onSwiper={(swiper) => {
            ref.current = swiper;
          }}
          className="w-full"
        >
          {data.values.map((value, i) => (
            <SwiperSlide key={i}>
              <Slide value={value} index={i} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <NavButton
        direction="left"
        canPress={!ref.current?.isBeginning}
        onPress={() => ref.current?.slidePrev()}
        className="-left-6 top-1/2 -translate-y-1/2"
      />
      <NavButton
        direction="right"
        canPress={!ref.current?.isEnd}
        onPress={() => ref.current?.slideNext()}
        className="-right-6 top-1/2 -translate-y-1/2"
      />
    </div>
  );
}


function NavButton(props: {
  className?: string;
  direction: "left" | "right";
  canPress: boolean;
  onPress: () => void;
}) {
  return (
    <button
      onClick={props.onPress}
      disabled={!props.canPress}
      className={X.clsx(
        "absolute z-10 w-10 h-10 flex items-center justify-center",
        "rounded-full shadow-sm transition-all",
        props.className,
        props.canPress
          ? "bg-white hover:bg-gray-50 text-black cursor-pointer"
          : "bg-gray-100 text-gray-400"
      )}
    >
      {props.direction === "left" ? (
        <X.Icon.ChevronLeft size={24} />
      ) : (
        <X.Icon.ChevronRight size={24} />
      )}
    </button>
  );
}


function Slide({ value, index }: {
  value: ViewModel['values'][number];
  index: number;
}) {
  // const tr = X.useTranslator();

  return (
    <div className={X.clsx(
      getColor(index),
      "p-4 xl:px-10 xl:py-8 flex flex-col gap-2 rounded-xl xl:rounded-2xl",
    )}>
      <div className="text-[60px] leading-[62px] xl:text-[66px] xl:leading-[68px]">{index + 1}</div>
      <div>
        <div className="text-[20px] xl:text-[26px] font-semibold mb-1 xl:mb-2">
          {/* {tr(value.title)} */}
          {/* {value.title} */}
          <ReactMarkdown>
            {value.title}
          </ReactMarkdown>
        </div>
        <div className="text-[16px] xl:text-[20px] xl:leading-[27px]">
          {/* {tr(value.text)} */}
          {/* {value.text} */}
          <ReactMarkdown>
            {value.text}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
}


function getColor(slideIndex: number) {
  const colorId = slideIndex % 3;

  if (colorId === 0) return "bg-surface-green" as const; // green
  if (colorId === 1) return "bg-surface-blue" as const; // blue
  if (colorId === 2) return "bg-surface-purple" as const; // purple

  return undefined! as never;
}
